(() => {
  const CONTROL_CLASS = 'custom-cart-notification-quantity';

  const updateSection = (id, html) => {
    const current = document.getElementById(id);
    if (!current || !html) return;

    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const matching = parsed.getElementById(id);
    const section = parsed.querySelector('.shopify-section');
    const source = matching || section;

    if (source) current.innerHTML = source.innerHTML;
  };

  const createControl = (notification) => {
    const links = notification.querySelector('.cart-notification__links');
    const viewCart = notification.querySelector('#cart-notification-button');
    if (!links || !viewCart) return null;

    let control = links.querySelector(`.${CONTROL_CLASS}`);
    if (control) return control;

    control = document.createElement('div');
    control.className = CONTROL_CLASS;
    control.setAttribute('role', 'group');
    control.setAttribute('aria-label', 'Quantity');
    control.innerHTML = `
      <button class="custom-cart-notification-quantity__button" type="button" data-action="decrease" aria-label="Decrease quantity">−</button>
      <span class="custom-cart-notification-quantity__value" aria-hidden="true">1</span>
      <button class="custom-cart-notification-quantity__button" type="button" data-action="increase" aria-label="Increase quantity">+</button>
      <span class="custom-cart-notification-quantity__status" role="status" aria-live="polite"></span>
    `;
    links.insertBefore(control, viewCart);

    let itemKey = '';
    let quantity = 1;
    let busy = false;
    const value = control.querySelector('.custom-cart-notification-quantity__value');
    const status = control.querySelector('.custom-cart-notification-quantity__status');
    const buttons = [...control.querySelectorAll('button')];

    const render = () => {
      value.textContent = String(quantity);
      buttons.forEach((button) => {
        button.disabled = busy;
      });
    };

    control.sync = async (key) => {
      itemKey = key || itemKey;
      if (!itemKey) return;

      try {
        const response = await fetch(`${window.routes.cart_url}.js`);
        const cart = await response.json();
        const item = cart.items.find((entry) => entry.key === itemKey);
        if (item) quantity = item.quantity;
        render();
      } catch (error) {
        console.error('Unable to load cart quantity.', error);
      }
    };

    const changeQuantity = async (change) => {
      if (busy || !itemKey) return;

      const nextQuantity = Math.max(1, quantity + change);
      if (nextQuantity === quantity) return;

      busy = true;
      render();

      try {
        const response = await fetch(window.routes.cart_change_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            id: itemKey,
            quantity: nextQuantity,
            sections: ['cart-icon-bubble', 'cart-notification-button'],
            sections_url: window.location.pathname,
          }),
        });
        const cart = await response.json();
        if (!response.ok || cart.status) throw new Error(cart.description || 'Unable to update quantity.');

        const item = cart.items.find((entry) => entry.key === itemKey);
        quantity = item ? item.quantity : nextQuantity;
        updateSection('cart-icon-bubble', cart.sections?.['cart-icon-bubble']);
        updateSection('cart-notification-button', cart.sections?.['cart-notification-button']);
        status.textContent = `Quantity updated to ${quantity}`;
      } catch (error) {
        status.textContent = error.message;
        console.error('Unable to update cart quantity.', error);
      } finally {
        busy = false;
        render();
      }
    };

    control.addEventListener('click', (event) => {
      const button = event.target.closest('[data-action]');
      if (!button) return;
      changeQuantity(button.dataset.action === 'increase' ? 1 : -1);
    });

    render();
    return control;
  };

  customElements.whenDefined('cart-notification').then(() => {
    const CartNotification = customElements.get('cart-notification');
    if (!CartNotification || CartNotification.prototype.customQuantityEnabled) return;

    CartNotification.prototype.customQuantityEnabled = true;
    const originalRenderContents = CartNotification.prototype.renderContents;

    CartNotification.prototype.renderContents = function renderContentsWithQuantity(parsedState) {
      originalRenderContents.call(this, parsedState);
      const control = createControl(this);
      control?.sync(parsedState.key);
    };

    document.querySelectorAll('cart-notification').forEach(createControl);
  });
})();
